<h2 mat-dialog-title>Request Action Plan</h2>
<label class="bl-textarea__label--bold">
  You are about to finish the ICR review, you will not be able to modify the results. Do you
  want to continue?
</label>
<br>
<p>
  Follow-up with executor has been selected, it is required to indicate the maximun term to upload
  the action plan:
</p>
<form [formGroup]="formData">
  
<div class="row-date">
  
  <span class="time-label">Limit Date:</span>
  <span class="bl-datepicker col-4">
    
    <p-calendar
    icon="pi pi-calendar"
    showIcon="true"
    selectionMode="single"
    dateFormat="yy/mm/dd"
    formControlName="reviewDateRange"
    class="reviewDateRangeValid"
    required
    [minDate]="minDate"
    [maxDate]="maxDate"
  ></p-calendar>
  </span>

  <div class="col-5">
    <!--a href="#" class="link-show-finding ">Show finding details</a-->
  </div>
</div>


</form>
<p>Finding selected:</p>
<mat-dialog-content class="mat-typography">
 
  <mat-selection-list #list [(ngModel)]="selectedOptions" >
    <mat-list-item *ngFor="let finding of icrData" [value]="finding.id">
     
        <div class="title">{{ finding.type }}</div>
        <div class="subtitle">{{ finding.buckets }}</div>
        <div class="content">{{ finding.text }}</div>
 
      <div class="divider"></div>
    </mat-list-item>
</mat-selection-list>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="" (click)="onCancelClick()">Cancel</button>
  <button mat-button class="bl-score__button bl-button--btn-secundary bl-button--btn-secundary--lg" [mat-dialog-close]="data" cdkFocusInitial (click)="SaveFinding()">Save</button>
</mat-dialog-actions>

